import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=4ae9db1a&scoped=true&"
import script from "./Section.vue?vue&type=script&lang=js&"
export * from "./Section.vue?vue&type=script&lang=js&"
import style0 from "./Section.vue?vue&type=style&index=0&id=4ae9db1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae9db1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae9db1a')) {
      api.createRecord('4ae9db1a', component.options)
    } else {
      api.reload('4ae9db1a', component.options)
    }
    module.hot.accept("./Section.vue?vue&type=template&id=4ae9db1a&scoped=true&", function () {
      api.rerender('4ae9db1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertactionplan/Section.vue"
export default component.exports